export default __webpack_public_path__ + "static/media/Magical Strings 2018 (242 of 264).532a35e6.jpg";